import { useState, useEffect } from "react";
import { Input, Button, App } from "antd";
import { UserService } from "@/services";

interface PhoneStepProps {
  onNext: (phone: string, registrationId: string) => void;
  onBack: () => void;
  phone: string;
}

export default function PhoneStep({
  onNext,
  onBack,
  phone: initialPhone,
}: PhoneStepProps) {
  const { message } = App.useApp();
  const [phone, setPhone] = useState(initialPhone);
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Validate phone format (09xxxxxxxx)
    const isPhoneValid = /^[09]{2}[0-9]{8}$/.test(phone);
    setIsValid(isPhoneValid);
  }, [phone]);

  const handleSendVerificationCode = async () => {
    if (!isValid) return;

    setLoading(true);
    try {
      const result = await UserService.initiateRegistration(phone);
      if (result.success && result.data) {
        message.success(result.message || "驗證碼已發送至您的手機");
        // Pass phone and registration_id to parent
        onNext(phone, result.data.registration_id);
      } else {
        // Show error message from service
        message.error(result.error || "發送驗證碼失敗");
      }
    } catch (error: unknown) {
      // Handle unexpected errors (network issues, etc.)
      const errorMessage =
        error instanceof Error ? error.message : "發送驗證碼失敗";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        backgroundColor: "white",
        overflow: "hidden",
      }}
    >
      <div style={{ padding: "12px", flex: 0 }}>
        <Input
          size="large"
          placeholder="手機號碼"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          maxLength={10}
          type="tel"
          style={{
            borderColor: "#d9d9d9",
            borderRadius: "4px",
            width: "100%",
          }}
          styles={{
            input: {
              fontSize: "16px",
            },
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          flexShrink: 0,
          height: "60px",
          width: "100%",
          padding: 0,
          margin: 0,
        }}
      >
        <Button
          size="large"
          onClick={onBack}
          style={{
            flex: 3,
            margin: "6px",
            border: "1px solid #FFCD14",
            borderRadius: "4px",
            color: "#FFCD14",
            backgroundColor: "transparent",
            height: "48px",
          }}
        >
          上一步
        </Button>
        <Button
          type="primary"
          size="large"
          onClick={handleSendVerificationCode}
          disabled={!isValid}
          loading={loading}
          style={{
            flex: 5,
            margin: "6px 6px 6px 0",
            borderRadius: "4px",
            backgroundColor: isValid ? "#FFCD14" : "#BDC1C9",
            borderColor: isValid ? "#FFCD14" : "#BDC1C9",
            color: "white",
            height: "48px",
          }}
        >
          取得驗證碼
        </Button>
      </div>
    </div>
  );
}
